/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';

interface InnerHeaderProps<D extends object> {
    column: SortableColumn<D>;
}

export function InnerHeader<D extends object>({
    column,
}: InnerHeaderProps<D>): JSX.Element {
    const { headerLabel } = column;

    return (
        <div className="w-full h-full font-semibold text-xs pr-1">
            <p>{headerLabel}</p>
        </div>
    );
}
